import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface profileState {
  employeeLoading: boolean;
  employeeError: any | null;
  employee: any | null;
  caseHistoryLoading: boolean;
  caseHistoryError: any | null;
  caseHistory: any | null;
  bankAccountDetailLoading: boolean;
  bankAccountDetailError: any | null;
  bankAccountDetail: any | null;
  viewRlhRewardsLoading: boolean;
  viewRlhRewardsError: any | null;
  viewRlhRewards: any | null;
}

const initialState: profileState = {
  employeeLoading: false,
  employeeError: null,
  employee: null,
  caseHistoryLoading: false,
  caseHistoryError: null,
  caseHistory: null,
  bankAccountDetailLoading: false,
  bankAccountDetailError: null,
  bankAccountDetail: null,
  viewRlhRewardsLoading: false,
  viewRlhRewardsError: null,
  viewRlhRewards: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    fetchEmployeeRequest(state, action) {
      state.employeeLoading = true;
      state.employeeError = null;
    },
    fetchEmployeeSuccess(state, action) {
      state.employeeLoading = false;
      state.employee = action.payload;
      state.employeeError = null;
    },
    fetchEmployeeFailure(state, action) {
      state.employeeLoading = false;
      state.employeeError = action.payload;
    },
    fetchCaseHistoryRequest(state, action) {
      state.caseHistoryLoading = true;
      state.caseHistoryError = null;
    },
    fetchCaseHistorySuccess(state, action) {
      state.caseHistoryLoading = false;
      state.caseHistory = action.payload?.cases;
      state.caseHistoryError = null;
    },
    fetchCaseHistoryFailure(state, action) {
      state.caseHistoryLoading = false;
      state.caseHistoryError = action.payload;
    },
    bankAccountDetailRequest(state, action: PayloadAction<any>) {
      state.bankAccountDetailLoading = true;
      state.bankAccountDetailError = null;
    },
    bankAccountDetailSuccess(state, action: PayloadAction<any>) {
      state.bankAccountDetailLoading = false;
      state.bankAccountDetail = action.payload;
      state.bankAccountDetailError = null;
    },
    bankAccountDetailFailure(state, action: PayloadAction<any>) {
      state.bankAccountDetailLoading = false;
      state.bankAccountDetailError = action.payload;
    },
    fetchViewRlhRewardsRequest(state, action) {
      state.viewRlhRewardsLoading = true;
      state.viewRlhRewardsError = null;
    },
    fetchViewRlhRewardsSuccess(state, action) {
      state.viewRlhRewardsLoading = false;
      state.viewRlhRewards = action.payload;
      state.viewRlhRewardsError = null;
    },
    fetchViewRlhRewardsFailure(state, action) {
      state.viewRlhRewardsLoading = false;
      state.viewRlhRewardsError = action.payload;
    },
  },
});

export const {
  fetchEmployeeRequest,
  fetchEmployeeSuccess,
  fetchEmployeeFailure,
  fetchCaseHistoryRequest,
  fetchCaseHistorySuccess,
  fetchCaseHistoryFailure,
  bankAccountDetailRequest,
  bankAccountDetailSuccess,
  bankAccountDetailFailure,
  fetchViewRlhRewardsRequest,
  fetchViewRlhRewardsSuccess,
  fetchViewRlhRewardsFailure,
} = profileSlice.actions;

export default profileSlice.reducer;
